import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ConceptoFactura;
export interface Props extends kea.ModalProps<Entity, boolean, boolean> {
}

/**
 * Valida un ConceptoFactura
 */
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        IdArticulo: validation.required,
        Cantidad: x => x.Cantidad > 0,
        PrecioUnitario: x => x.PrecioUnitario > 0,
        Descripcion: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Modal de edición para un ConceptoFactura
*/
export class ConceptoFacturaEdit extends React.PureComponent<Props, { Total: number, Subtotal: number }> {
    constructor(props: Props) {
        super(props);
        this.state = { Total: 0, Subtotal: 0 };
    }

    value = (props: Props) => props.value;
    esPersonaMoral = (props: Props) => props.params;

    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    Subtotal = createSelectorRx(this.value, value => (value.PrecioUnitario ? value.PrecioUnitario : 0) * (value.Cantidad ? value.Cantidad : 0));
    IEPS = createSelectorRx(this.value, this.Subtotal, (value, subtotal) => (value.TasaIeps ? value.TasaIeps : 0) * subtotal);
    IVA = createSelectorRx(this.value, this.Subtotal, (value, subtotal) => (value.TasaIva ? value.TasaIva : 0) * subtotal);
    IVARetenido = createSelectorRx(this.value, this.Subtotal, (value, subtotal) => (value.TasaRetencionIva ? value.TasaRetencionIva : 0) * subtotal);

    Total = createSelectorRx(this.IVA, this.IEPS, this.IVARetenido, this.Subtotal, (IVA, IEPS, IVARetenido, subtotal) => subtotal + IEPS + IVA - IVARetenido);

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }

    private onHandleArticuloChange = async (idArticulo: number) => {
        const viejo = this.props.value;
        const cambioArticulo: Partial<Entity> = { IdArticulo: idArticulo, };
        this.props.onChange({ ...viejo, ...cambioArticulo });

        var articulo = await resources.Articulo.getMemo(idArticulo);
        const nuevo = this.props.value;

        var preciounitario = articulo.PrecioUnitario ? articulo.PrecioUnitario : 0;
        var iva = articulo.TasaIva ? articulo.TasaIva : 0;
        var ieps = articulo.TasaIeps ? articulo.TasaIeps : 0;

        const cambio: Partial<Entity> = {
            Descripcion: articulo.Nombre,
            PrecioUnitario: preciounitario,
            TasaIeps: ieps,
            TasaIva: iva
        };
        this.props.onChange({ ...nuevo, ...cambio });
    }

    render() {
        const value = this.props.value;
        const getField = this.getField;
        const Text = getField(kea.Text);
        const DateTime = getField(kea.DateTime);
        const Number = getField(kea.Number);
        const Articulos = getField(selectores.Articulo);
        const hasError = this.hasError(this.props);
        const esPersonaMoral = this.esPersonaMoral(this.props);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Editar Concepto de factura"
            >

                {kea.autogrid(6, [
                    <Articulos field="IdArticulo" onChange={this.onHandleArticuloChange} label="Artículo:" />,
                    <Number field="Cantidad" label="Cantidad:" />,
                    <Number field="PrecioUnitario" label="Precio unitario:" />,
                    <Number field="TasaIva" label="Tasa Iva:" format="percentage" />,
                    <Number field="TasaIeps" label="Tasa IEPS:" format="percentage" />,
                    <Number field="TasaRetencionIva" label="Tasa Retención Iva:" format="percentage" readonly={!esPersonaMoral} />,
                ])}
                <kea.Number label="Subtotal" value={this.Subtotal(this.props)} format="currency" readonly={true} />,
                <kea.Number label="Retenido" value={this.IVARetenido(this.props)} format="currency" readonly={true} />
                <kea.Number label="Total" value={this.Total(this.props)} format="currency" readonly={true} />,
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/edit/componentes/conceptos/edit.tsx